<template>
  <div class="rate">
    <span class="is-active"></span>
    <span :class="{ 'is-active': Number(level) >= 2 }"></span>
    <span :class="{ 'is-active': Number(level) >= 3 }"></span>
    <span :class="{ 'is-active': Number(level) >= 4 }"></span>
    <span :class="{ 'is-active': Number(level) >= 5 }"></span>
  </div>
</template>

<script lang="ts">
export default {
  name: 'Rate',

  props: {
    level: {
      type: Number,
      default: 1
    }
  }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.rate {
  height: 14px;
  display: flex;

  span {
    display: block;
    width: 14px;
    height: 14px;
    margin-left: 3px;
    background-image: url('~@/assets/icon/star.svg');
    background-size: 100% 100%;

    &.is-active {
      background-image: url('~@/assets/icon/star_on.svg');
    }
  }

  @include mixins.media() {
    height: 20px;
    span {
      width: 20px;
      height: 20px;
      margin-left: 5px;
    }
  }
}
</style>
